import { useState } from 'react';
import Tooltip from "@mui/material/Tooltip";
import { Zoom, Menu, MenuItem, Button } from "@mui/material";

const TrySampleText = ({handleSampleButtonClick, toggleDropup , sampleButtonText }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
    toggleDropup(); // Toggle the drop-up on button click
  };

  const handleClose = () => {
    setAnchorEl(null);
    toggleDropup(); // Close when selecting an item
  };

  return (
    <div className="relative text-[#f4833d] cursor-pointer text-center rounded border border-[#c6530c]">
      <Tooltip
        title="Try a Sample Text"
        arrow
        placement="top"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
      >
        <Button
          className="dropdown-button title-input w-[18vw] py-2 flex align-middle place-content-center justify-center items-center hover:bg-[#929292] hover:text-white rounded"
          onClick={handleButtonClick}
        >
          <span className='text-xs text-[#c6530c]'>{sampleButtonText}
          <span>
            <i className="fa-solid fa-caret-up mx-4"></i>
          </span>
          </span>
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'top', // Position the dropdown above the button
            horizontal: 'center', // Align the dropdown horizontally to the center of the button
          }}
          transformOrigin={{
            vertical: 'bottom', // Align the bottom of the dropdown to the top of the button
            horizontal: 'center', // Align the dropdown horizontally to the center of the button
          }}
      >
        <MenuItem className="dropdown-item-domain hover:rounded-xl" onClick={() => {handleSampleButtonClick("Private Pension"); handleClose();}}>
          Private Pension
        </MenuItem>
        <MenuItem className="dropdown-item-domain hover:rounded-xl" onClick={() => {handleSampleButtonClick("Tracker Rate Mortgage"); handleClose();}}>
          Tracker Rate Mortgage
        </MenuItem>
        <MenuItem className="dropdown-item-domain hover:rounded-xl" onClick={() => {handleSampleButtonClick("Fixed Rate Mortgage"); handleClose();}}>
          Fixed Rate Mortgage
        </MenuItem>
        <MenuItem className="dropdown-item-domain hover:rounded-xl" onClick={() => {handleSampleButtonClick("Home Insurance"); handleClose();}}>
          Home Insurance
        </MenuItem>
        <MenuItem className="dropdown-item-domain hover:rounded-xl" onClick={() => {handleSampleButtonClick("Car Insurance"); handleClose();}}>
          Car Insurance
        </MenuItem>
      </Menu>
    </div>
  );
};

export default TrySampleText;
